export default {
  titles: {
    pickup: 'Ridicare',
    delivery: 'Livrare',
  },
  buttons: {
    confirm: 'Confirmă',
  },
};
